var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterbtcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.1 0 346.71 274.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".interbtc-logo-1{fill:#1a0a2d}.interbtc-logo-2{fill:#f90}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "interbtc-logo-1",
    d: "M340.47 274.91H105.54a6.1 6.1 0 0 1-3.17-.9L17.49 221.6a6 6 0 0 1 3.17-11.17h234.93a6 6 0 0 1 3.17.9l84.88 52.4a6 6 0 0 1-3.17 11.18Zm-233.22-12.08h212l-65.37-40.33h-212ZM325.85 64.48H90.92a6.1 6.1 0 0 1-3.17-.9L2.86 11.17A6 6 0 0 1 6 0h235a6.1 6.1 0 0 1 3.17.9L329 53.31a6 6 0 0 1-3.17 11.17ZM92.63 52.41h212l-65.37-40.34h-212Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "interbtc-logo-2",
    d: "M177.46 134.26c4.87 0 11.3-.55 14.91-4.22a8.29 8.29 0 0 0 2.74-6.33c-.12-8.35-7-11.3-13.45-11.28h-9.7l.06 21.43 1.1.13a39.18 39.18 0 0 0 4.34.27ZM182.3 141.19l-10.24.11.08 25.13H182.51c7.6 0 15.72-3.35 15.74-12.61a11.22 11.22 0 0 0-3.18-8.29c-4.07-4.05-10.8-4.35-12.77-4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "interbtc-logo-2",
    d: "M221.64 93.77a60.85 60.85 0 0 0-43.2-16.51h-.64a61.21 61.21 0 0 0 3.42 122.37h.61a61.21 61.21 0 0 0 39.81-105.86ZM203.36 170a34.17 34.17 0 0 1-11.86 2.37h-1.24l-.1 1.24v12.11h-9.07v-13.44l-8.93.07v13.35h-9.14l-.02-13.3-15.36.12v-6h5.7a4.36 4.36 0 0 0 4.34-4.37l-.15-45.31c0-2.26-1.8-3.83-4.36-3.83l-5.72-.4v-8.36h15.52V90.48h9v13.79h9V90.45h9v13.83h1.66c3.11 0 18.7 3.24 18.74 15.86 0 13.91-11.66 15.41-11.86 15.83l-.62.05c.65.07 15.88 3 15.77 19.11-.09 6.98-3.47 11.97-10.3 14.87Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterbtcLogo);
export default __webpack_public_path__ + "static/media/interbtc-logo.072a54ce.svg";
export { ForwardRef as ReactComponent };